export default __webpack_public_path__ + "static/hop_helles-e35fab95837bbba03a40853e249da60c.png";